"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHTMLContainer = exports.transformHTML = exports.StyledReportCardsContainer = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const htmr_1 = __importDefault(require("htmr"));
const base_react_components_1 = require("@navinc/base-react-components");
exports.StyledReportCardsContainer = styled_components_1.default.div.withConfig({ displayName: "reports-StyledReportCardsContainer", componentId: "reports-1anpf0j" }) `
  display: grid;
  grid-row-gap: 16px;

  @supports not (display: grid) {
    display: flex;
    flex-direction: column;

    & > * {
      margin-bottom: 16px;
    }
  }
`;
const transform = {
    b: (node, props, children) => {
        var _a;
        return (react_1.default.createElement(base_react_components_1.Copy, Object.assign({ bold: true }, props), (_a = node === null || node === void 0 ? void 0 : node.children) !== null && _a !== void 0 ? _a : children));
    },
    p: base_react_components_1.Copy,
    span: base_react_components_1.Copy,
    h2: (node, props, children) => {
        var _a;
        return (react_1.default.createElement(base_react_components_1.Header, Object.assign({ size: "md" }, props), (_a = node === null || node === void 0 ? void 0 : node.children) !== null && _a !== void 0 ? _a : children));
    },
    h3: (node, props, children) => {
        var _a;
        return (react_1.default.createElement(base_react_components_1.Header, Object.assign({ size: "sm" }, props), (_a = node === null || node === void 0 ? void 0 : node.children) !== null && _a !== void 0 ? _a : children));
    },
    h4: (node, props, children) => {
        var _a;
        return (react_1.default.createElement(base_react_components_1.Header, Object.assign({ size: "xs" }, props), (_a = node === null || node === void 0 ? void 0 : node.children) !== null && _a !== void 0 ? _a : children));
    },
};
const transformHTML = (content = '') => (0, htmr_1.default)(content, { transform });
exports.transformHTML = transformHTML;
exports.StyledHTMLContainer = styled_components_1.default.div.withConfig({ displayName: "reports-StyledHTMLContainer", componentId: "reports-okjcxc" }) `
  color: currentColor;
`;
//# sourceMappingURL=examples-styles.js.map